export { default } from './MemberDataCaptureMessageContent';
